import React from 'react';
import { useSelector } from 'react-redux';
import Skeleton from '@mui/material/Skeleton';
import { ListOfKeysFilterAllData } from 'src/typings/filter';
import { getSelectedAppartment, getIsOpenAppartSidebar } from 'src/store/app/selectors';
import {
  crossTableBigItemHeight,
  crossTableBigItemWidth,
} from 'src/constants';
import { IFloorItemBig } from './index';
import { useStyles } from '../../styles';

export const FloorItemBigSkeleton: React.FC<IFloorItemBig> = ({
  fillFloorsItem,
}) => {
  const styles = useStyles({});
  const selectedAppartment = useSelector(getSelectedAppartment);
  const isOpenAppartSidebar = useSelector(getIsOpenAppartSidebar);
  // The selected unit may be off-screen (virtualized to a skeleton) — still mark
  // it so the auto-center effect can scroll to it before it renders in full.
  // eslint-disable-next-line eqeqeq
  const isSelectedCell = isOpenAppartSidebar && selectedAppartment == fillFloorsItem[ListOfKeysFilterAllData.id];

  return (
    <div className={styles.sectionContentWrapperBig} data-selected-cell={isSelectedCell ? 'true' : undefined}>
      <Skeleton
        variant="rectangular"
        animation="wave"
        width={crossTableBigItemWidth}
        height={crossTableBigItemHeight * fillFloorsItem[ListOfKeysFilterAllData.placementFloor].length}
        style={{
          borderRadius: '5px',
          position: 'absolute',
          bottom: 0,
        }}
      />
    </div>
  );
};
